// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Alert_wrapper__2RvSd","root":"Alert_root__24kox","icon":"Alert_icon__2JAk6","error":"Alert_error__3ZIRi","warning":"Alert_warning__3H2g8"};